// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2ryTX","navText":"Navbar_navText__1PN4-","navLogo":"Navbar_navLogo__2Z26B","imgLogo":"Navbar_imgLogo__mxqgd"};